/**
 * This is an abstraction layer for the trellis-theme.
 * It allows quickly update the theme once nav color tokens are available
 */
import { PANTERA, HEFFALUMP, SLINKY, GREAT_WHITE, GYPSUM, EERIE, OLAF } from 'HubStyleTokens/colors';
import memoizeOne from 'react-utils/memoizeOne';
const getThemeNameFromLocalStorage = () => {
  try {
    const themeName = localStorage.getItem('trellis:theme');
    return themeName;
  } catch (error) {
    return null;
  }
};
export const navTheme = memoizeOne(__theme => {
  // This if for testing migration progress only!
  const themeName = getThemeNameFromLocalStorage();
  if (themeName === 'nav-trellis-dark') {
    return {
      navBgPrimary: '#141414',
      navBgSecondary: '#292929',
      navBgTertiary: '#333333',
      navBorderPrimary: '#333333',
      navBorderSecondary: '#333333',
      navBorderTertiary: '#333333',
      navTextPrimary: '#E7E5E4',
      navTextSecondary: '#B6B1AF',
      navTextTertiary: '#9B9897',
      navIconPrimary: '#CFCCCB',
      navIconSecondary: '#B6B1AF',
      navIconTertiary: '#9B9897',
      navIconSubtle: '#333333'
    };
  }
  if (themeName === 'nav-trellis-light') {
    return {
      navBgPrimary: '#ffffff',
      navBgSecondary: '#F5F8FA',
      navBgTertiary: '#EAF0F6',
      navBorderPrimary: '#CBD6E2',
      navBorderSecondary: '#CBD6E2',
      navBorderTertiary: '#CBD6E2',
      navTextPrimary: '#33475B',
      navTextSecondary: '#516F90',
      navTextTertiary: '#99ACC2',
      navIconPrimary: '#33475B',
      navIconSecondary: '#516F90',
      navIconTertiary: '#CBD6E2',
      navIconSubtle: '#EAF0F6'
    };
  }
  return {
    navBgPrimary: PANTERA,
    navBgSecondary: HEFFALUMP,
    navBgTertiary: SLINKY,
    navBorderPrimary: SLINKY,
    navBorderSecondary: HEFFALUMP,
    navBorderTertiary: EERIE,
    navTextPrimary: GREAT_WHITE,
    navTextSecondary: GYPSUM,
    navTextTertiary: OLAF,
    navIconPrimary: GREAT_WHITE,
    navIconSecondary: GYPSUM,
    navIconTertiary: EERIE,
    navIconSubtle: SLINKY
  };
});